import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import dmbot from "../../Assets/Projects/dmbot.png"
import hostguru from "../../Assets/Projects/hostguru.png"
import simply from "../../Assets/Projects/simply.png"

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Metaloops"
              description="Metaloops, developed at Octaloop Technologies, is a React-based project designed to streamline metalworking processes, enhancing efficiency and precision through digital tools and automation"
              ghLink="https://github.com/Octaloop-Technologies/metaloops"
              demoLink="https://metaloops.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Autored"
              description="AutoRed, powered by React.js from Octaloop Technologies, offers a streamlined platform for browsing vehicles with advanced search and real-time updates, enhancing your car exploration experience."
              ghLink="https://github.com/Octaloop-Technologies/auto-red"
              demoLink="https://auto-red.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Kenna AI"
              description="developed Kenna AI at Octaloop Tech, leveraging React.js to create a user-friendly interface for streamlined PDF to Excel conversion and automated data analysis, empowering businesses with efficient financial management solutions."
              ghLink="https://github.com/Octaloop-Technologies/kenna-pdf-ai"
              demoLink="https://kenna-pdf-ai.vercel.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dmbot}
              isBlog={false}
              title="DM bot"
              description="Development of dashboards and multiple landing pages for the DM-Bot project at Octaloop Tech, utilizing React.js to create dynamic interfaces and engaging user experiences that drive conversions and enhance user engagement."
              ghLink="https://github.com/Octaloop-Technologies/dm-bot"
              demoLink="https://dm-bot-five.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hostguru}
              isBlog={false}
              title="Host Guru"
              description="Crafted landing pages and implemented a chatbot for HostGuru at Octaloop Tech, enhancing user interaction and facilitating seamless communication to provide visitors with valuable information and support."
              ghLink="https://github.com/Octaloop-Technologies/host-guru"
              demoLink="https://host-guru.vercel.app/" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={simply}
              isBlog={false}
              title="Simly-4.0"
              description="I collaborated with fellow developers to contribute to the front-end of Simply-4.0, crafting engaging landing pages and ensuring a seamless user experience at Octaloop Tech."
              ghLink="https://github.com/Octaloop-Technologies/simpli-4.0"
              demoLink="https://simpli-rfp-4.vercel.app/"      
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
